export const FIELD_LABELS: Record<string, string> = {
  // Паспорт
  passportNumber: 'Серия и номер паспорта',
  passportIssueDate: 'Дата выдачи паспорта',
  passportIssued: 'Кем выдан паспорт',
  divisionCode: 'Код подразделения',
  birthPlace: 'Место рождения',
  registrationAddress: 'Адрес регистрации',
  citizenship: 'Гражданство',
  birthDate: 'Дата рождения',
  // ВУ
  firstName: 'Имя',
  middleName: 'Отчество',
  lastName: 'Фамилия',
  drivingLicenseNumber: 'Номер ВУ',
  drivingLicenseIssueDate: 'Дата выдачи ВУ',
  drivingLicenseExpirationDate: 'Дата окончания ВУ',
  drivingExperienceStartDate: 'Дата начала водительского стажа',
  previousDrivingLicenseNumber: 'Предыдущий номер ВУ',
}

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  'driver-license-front': 'Водительское удостоверение (лицевая сторона)',
  'driver-license-back': 'Водительское удостоверение (обратная сторона)',
  passport: 'Паспорт',
}
